@import 'styles/blaze/colors';

.root {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tabs {
  display: flex;
}

.tabsContainer {
  width: 100%;
  overflow: hidden;
  height: 100%;
}

.tabsContainerInner {
  transition: transform 0.2s ease-in-out;
  height: 100%;
}

.tabContent {
  padding: 24px 0 0 0;
  display: inline-block;
  vertical-align: top;
}
